import {isValidHighlightSlice} from 'lib/geoUtils'

export const validatedHighlightSlice = (blockData, ride) => {
  if (!blockData || !ride) {
    return null
  }
  const _hs = blockData.get('highlightSlice')
  const highlightSlice = (ride && isValidHighlightSlice(_hs, ride.trackPoints))
    ? _hs
    : null
  return highlightSlice
}
